import { useWalletNetworksQuery } from '../data-access';

export const useWalletNetworks = () => {
	const Default_Explorer_Url = 'https://scan.chiliz.com/tx/';
	const Default_History_Url = 'https://scan.chiliz.com/token/';
	const { data, isLoading } = useWalletNetworksQuery({
		'types[]': ['cc2']
	});

	const cc2WalletNetwork = data?.find(d => d.type === 'cc2');

	/**
	 * Get Chain Explorer URL for transaction details
	 * The below code removes "{hash}"
	 * Example of "explorerUrl": https://scan.chiliz.com/tx/{hash}
	 */
	const explorerUrl = cc2WalletNetwork?.config?.explorerUrl;
	const explorerCurlyBracketIndex = explorerUrl?.indexOf('{');
	const chainExplorerUrl =
		!!explorerUrl && explorerCurlyBracketIndex !== -1
			? explorerUrl.slice(0, explorerCurlyBracketIndex)
			: Default_Explorer_Url;

	/**
	 * Get History URL for all history records
	 * The below code removes "{hash}"
	 * Example of "tokenExplorerUrl": https://scan.chiliz.com/token/{hash}
	 */
	const tokenExplorerUrl = cc2WalletNetwork?.config?.tokenExplorerUrl;
	const historyCurlyBracketIndex = tokenExplorerUrl?.indexOf('{');
	const historyUrl =
		!!tokenExplorerUrl && historyCurlyBracketIndex !== -1
			? tokenExplorerUrl.slice(0, historyCurlyBracketIndex)
			: Default_History_Url;

	return {
		chainExplorerUrl,
		historyUrl,
		isWalletNetworksLoading: isLoading
	};
};
